import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { fetchDossierSubTypes, fetchAuditConfigurationType, fetchDossierTypes } from '../../actions/combos/combos'
import { initializeSearch, resetFilters } from '../../actions/search/search'
import { openModal, yesNoModal } from '../../actions/common'
import { fetchAuditAdminInfo, resetFiltersAuditAdminInfo, openAuditAdminModal, deleteAuditAdmin } from '../../actions/management/management'
import AuditAdmin from '../../components/management/AuditAdmin'

export function mapStateToProps (state) {
  return {
    ...state.management.auditAdmin,
    combos: {
      ...state.combos
    }
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      deleteAuditAdmin,
      openAuditAdminModal,
      fetchDossierSubTypes,
      fetchAuditConfigurationType,
      fetchDossierTypes,
      initializeSearch,
      resetFilters,
      openModal,
      yesNoModal,
      fetchAuditAdminInfo,
      resetFiltersAuditAdminInfo
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(AuditAdmin))
